import spartaEventsUtility from "global/sparta-events-utility";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";
import spartaStoreUtility from "global/sparta-store-utility";
import Handlebars from "vendor/handlebars";
import hbs from "vendor/handlebars";
import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaBootstrapUtility from "global/sparta-bootstrap-utility";
import spartaTransportUtility from "global/sparta-transport-utility";
import spartaMessageUtility from "global/sparta-messaging-utility";
import spartaRequireUtility from "global/sparta-require-utility";
import moduleContainer from "helpers/module-container";
import Communicator from "utilities/global/sparta-module-utility/3.5.0/js/communicator";
export default class View extends Communicator {
  constructor( options ) {
    super( options.settings );

    let defaults = {};

    this.settings = defaults;
    this.settings = $.extend(defaults, options.settings);

    this.model = options.model;

    this._initialize();
  }

  _initialize() {

  }

}